<script>
  import { Router, Link, Route } from 'svelte-navigator';
  import RouteTransition from '../RouteTransition.svelte';
  import { fly, blur } from 'svelte/transition';
  import Paths from '../Utils/Paths.svelte';
  import {
    idTrappe,
    type,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    couleur,
  } from '../stores.js';

  import ChoixTrappe from '../Pages/ChoixTrappe.svelte';
  import TitleNNumber from '../ComponentsInProcess/TitleNNumber.svelte';
  import BtnPageMetalique from '../ComponentsInProcess/btnPageMetalique.svelte';
  import RangeSliderMetallique from '../ComponentsInProcess/range-slider-1-metallique.svelte';
  export let idFiche;

  // var namestore;
  // let valuestore;
  // let idstore;

  // console.log(`$idTrappe - 1Metallic : ${$idTrappe}`);
  // console.log(`idFiche - 1Metallic : ${idFiche}`);
</script>

{#if idFiche == 1}
  <Paths namestore="type" />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageMetalique idFiche="{idFiche}" idBtn="1" titre="{'Mur'}" />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageMetalique idFiche="{idFiche}" idBtn="2" titre="{'Plafond'}" />
    </div>
  </div>
  <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
    <p class="as-notes" style="">
      Important : Ce type de trappe ne supporte pas une installation au sol
    </p>
  </div>
{:else if idFiche == 2}
  <Paths namestore="Longueur" />
  <div in:fly="{{ x: 100, duration: 800 }}">
    <RangeSliderMetallique
      idFiche="{idFiche}"
      titre="{'Longueur'}"
      soustitre="{'avec une l'}"
    />
  </div>
{:else if idFiche == 3}
  <Paths namestore="sensOuverture" />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageMetalique
        idFiche="{idFiche}"
        idBtn="3"
        titre="{'Sur le côté de <br />' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageMetalique
        idFiche="{idFiche}"
        idBtn="4"
        titre="{'Sur le côté de <br />' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{:else if idFiche == 4}
  <Paths namestore="fermeture" />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageMetalique
        idBtn="5"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageMetalique idBtn="6" idFiche="{idFiche}" titre="{'Clé carrée'}" />
    </div>
    <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
      <BtnPageMetalique
        idBtn="7"
        idFiche="{idFiche}"
        titre="{'Clé boite aux lettres'}"
      />
    </div>
  </div>
{:else if idFiche == 5}
  <Paths namestore="couleurIdFiche" />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageMetalique idBtn="8" idFiche="{idFiche}" titre="{'Blanc'}" />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageMetalique idBtn="9" idFiche="{idFiche}" titre="{'Blanc Mat'}" />
    </div>
    <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
      <BtnPageMetalique
        idBtn="10"
        idFiche="{idFiche}"
        titre="{'Choisir son RAL'}"
      />
    </div>
  </div>
{/if}
